
/** 
 * This Mixin describes the owner of a List with a cursor where one element is selected. The selection is
 * statefully represented in the browser history and location bar.
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
*/

export {  ListWithCursor  };

var ListWithCursor = {

	/*
		args:	an array of arguments
		level:	position in the argument array intended for consumption by this list
	*/
	props: ["args", "level"],

	data: function() {
		return {
			// starting coordinates of a touch event
			touchCord: [0, 0],

			// A list of Works
			list: [],
			// The selected element
			cursor: -1
		};
	},

	computed: {
		maxIndex: function() {
			return this.list.length - 1;
		},
		minIndex: function() {
			return 0;
		}
	},

	methods: {

		/** Update the Selection based on the arguments */
		parseArgs: function() {
			if (this.args.length >= this.level && this.args [this.level] != '') {
				for (let i = 0; i < this.list.length; i++) {
					if (this.list [i].acceptURLTerm(this.args [this.level])) {
						this.select(i, false);
						return;
					}
				}
				// no match: select nothing
				this.select(null, false);
			} else {
				// no argument: select nothing
				this.select(null, false);
			}				
		},

		// Register the start coordinates of a touch event
		touchStartSelect: function(event) {
			this.touchCord = [
				event.changedTouches [0].pageX,
				event.changedTouches [0].pageY
			];
		},

		// Register the end coordinates of a touch event
		touchEndSelect: function(event, index) {
			let endpoint = [
				event.changedTouches [0].pageX,
				event.changedTouches [0].pageY
			];
			let deltaY = endpoint [1] - this.touchCord [1];
			let deltaX = endpoint [0] - this.touchCord [0];

			if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 20) {
				this.select(index + (deltaX > 0? -1 : 1));
				if (typeof event.cancelable !== 'boolean' || event.cancelable) {
					event.preventDefault();
				}
			}
			this.touchCord = [0, 0];
		},		


		/** 
		 * Change the Selected Element within the list
		 * 
		 * @param index 		new position. Will be mapped to possible values. leave empty or null for no selection
		 * @param pushState 	put the selection on the history and location bar. Default is true.
		*/
		select: function(index, pushState) {

			if (typeof pushState === "undefined") {
				pushState = true;
			}
			if (typeof index === "undefined" || index == null) {
				this.cursor = -1;					
			} else {
				if (index < this.minIndex) {
					index = this.minIndex;
				}
				if (index > this.maxIndex) {
					index = this.maxIndex;
				}
				this.cursor = index;
			}

			if (pushState) {
				let baseArgs = this.args.slice(0, this.level);
				if (typeof index !== "undefined") {
					baseArgs.push(this.list [index].getURLTerm());
					this.$root.$children [0].pushState(null, baseArgs);
				} else {
					this.$root.$children [0].pushState(null, baseArgs);
				}
			}	

		}
	},

	watch: {
		args: function() {
			this.parseArgs();
		}
	},

	// use the beforeMount hook to ensure it applies after the created hook of the components
	// which they may use to prepare their lists
	beforeMount: function() {
		this.parseArgs();
	}

}